import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import AppContext from '../../../contexts/AppContext';
import './ConfirmQuitModal.css';

class ConfirmQuitModal extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
    };
  }

  componentDidUpdate(prevProps, prevState) {}

  render() {
    const { dictionnary } = this.context;
    const { onCloseHandler, onConfirmationHandler, onCancelHandler } = this.props;
    const { open } = this.state;

    return (
      <>
        <ClickAwayListener
          onClickAway={() => {
            if (onCloseHandler) {
              onCloseHandler();
            }
          }}
        >
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modal"
            open={open}
            onClose={() => {
              if (onCloseHandler) {
                onCloseHandler();
              }
            }}
            closeAfterTransition
            BackdropComponent={Backdrop}
            disableEnforceFocus
            disableAutoFocus
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={open}>
              <div className="paper">
                <h2 id="transition-modal-title">
                  {dictionnary.get('leave-title')}
                </h2>
                <p id="transition-modal-description">
                  {dictionnary.get('leave-descr')}
                </p>

                <button
                  type="button"
                  className="main-button main-button--outline start-btn"
                  onClick={() => {
                    if (onConfirmationHandler) {
                      onConfirmationHandler();
                    }
                  }}
                >
                  {dictionnary.get('common-leave-gallery')}
                </button>
                <button
                  type="button"
                  className="main-button main-button--inverted start-btn"
                  onClick={() => {
                    if (onCancelHandler) {
                      onCancelHandler();
                    }
                  }}
                >
                  {dictionnary.get('common-return-gallery')}
                </button>
              </div>
            </Fade>
          </Modal>
        </ClickAwayListener>
      </>
    );
  }
}

export default ConfirmQuitModal;
